import React from "react";
import PropTypes from "prop-types";
import { Box, TextareaAutosize } from "@material-ui/core";

//styles
import useStyles from "./styles";

const CustomTextArea = ({
  value,
  maxRows,
  minRows,
  placeholder,
  onInputChange,
  hasError,
  errorMessage,
  submitted,
}) => {
  const styles = useStyles();

  const handleInputChange = (event) => {
    if (onInputChange) {
      onInputChange(event.target.value);
    }
  };

  return (
    <Box className={styles.wrapperTextArea}>
      <TextareaAutosize
        maxRows={maxRows}
        minRows={minRows}
        placeholder={placeholder}
        className={`${styles.textAreaInput} ${hasError ? styles.error : ""}`}
        onChange={handleInputChange}
        value={value}
      />
      {hasError && errorMessage && submitted && (
        <div className={styles.errorMessage}>{errorMessage}</div>
      )}
    </Box>
  );
};

CustomTextArea.propTypes = {
  maxRows: PropTypes.number,
  minRows: PropTypes.number,
  placeholder: PropTypes.string,
  onInputChange: PropTypes.func,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  submitted: PropTypes.bool,
};

CustomTextArea.defaultProps = {
  maxRows: 3,
  minRows: 1,
  placeholder: "Type your text here...",
  onInputChange: () => {},
  hasError: false,
  errorMessage: "",
  submitted: false,
};

export default CustomTextArea;
